<template>
<div>
  <b-card title="Job History" no-body>
    <b-card-header>
      <div class="d-flex">
        <div class="p-1">
          <h3>Job History</h3>
        </div>
        <div class="ml-auto p-1">
          <b-button-group size="sm">
            <b-button
              variant="success"
              @click="switchView('list')"
              class="img-icon img-icon-bullet-list"
              v-bind:class="{ 'active' : getDefaultView !== 'card'  }">
            </b-button>
            <b-button
              variant="success"
              @click="switchView('card')"
              class="img-icon img-icon-drawer"
              v-bind:class="{ 'active' : getDefaultView === 'card' }">
            </b-button>
          </b-button-group>
        </div>
        <div class="p-1">
          <b-input-group size="sm">
            <b-form-input
              v-model="filterSearch"
              v-on:keyup.enter="searchClicked"
              type="search"
              id="jobNameTagSearchInput"
              placeholder="Name Search"
            ></b-form-input>
          </b-input-group>
        </div>
        <div class="p-1">
          <b-button v-b-toggle.collapse-job-filters size="sm" v-b-popover.hover.left="'Advanced Search Filters'" variant="outline-primary">Advanced</b-button>
        </div>
        <div class="p-1">
          <b-button @click="searchClicked" size="sm" v-b-popover.hover.left="'Run Search Query'" variant="outline-primary">Search</b-button>
        </div>
      </div>
      <div>
        <b-collapse id="collapse-job-filters">
          <b-card class="mb-0">
            <b-form>
              <b-form-group
                id="advance-search-group"
                label="Advance Search"
                label-for="advanceSearch"
              >
                <b-form-input
                  v-model="searchTerm"
                  type="search"
                  id="advanceSearch"
                  placeholder="Advance Search"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-row class="col-12">
                  <b-form-group
                    label="Date Start"
                    label-for="filterDateStart"
                    class="col-4"
                  >
                  <b-form-input
                    v-model="filterDateStart"
                    type="date"
                    id="filterDateStart"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Date Finish"
                    label-for="filterDateFinish"
                    class="col-4"
                  >
                  <b-form-input
                    v-model="filterDateFinish"
                    type="date"
                    id="filterDateFinish"
                    ></b-form-input>
                  </b-form-group>
                </b-row>
              </b-form-group>
              <b-form-group>
                <b-button variant="outline-primary" @click="jobAdvanceSearch">Search</b-button>
              </b-form-group>
            </b-form>
          </b-card>
        </b-collapse>
      </div>
    </b-card-header>

    <!-- Card Body -->
    <b-card-body >
      <div v-if="!this.session.loadedFirstPage" class="text-center p-3"><b-spinner size="sm"></b-spinner></div>
      <div v-else>
        <div v-if="jobList && jobList.length > 0">
          <template v-if="getDefaultView === 'card'">
            <job-card-view
              v-for="(job,idx) in jobList"
              v-bind:key="idx"
              :object="job"
              :name="job.name"
              :link="`/jobs/${job.jobId}`"
              :date="job.dateFinished">
            </job-card-view>
          </template>

          <b-table
            id="job-search-table"
            ref="jobSearchTable"
            responsive
            :items="jobList"
            :fields="fields"
            v-else
          >
            <!-- Thumb Cell -->
            <template v-slot:cell(thumb)="row" >
              <!-- this is the 4 thumbs alternative -->
              <div class="hw-fixed">
                <job-media-wrapper :job="row.item"></job-media-wrapper>
              </div>
            </template>

            <!-- Name Cell -->
            <template v-slot:cell(name)="row" >
              <router-link :to="{ name: 'Job Details', params: { jobId: row.item.jobId }}">{{ row.item.name ? row.item.name : 'No Name' }}</router-link>
            </template>

            <!-- Date Cell -->
            <template v-slot:cell(date)="row" >
              <span> {{ $moment(row.item.dateStarted).calendar() }} </span>
            </template>

            <!-- Size Cell -->
            <template v-slot:cell(size)="row" >
              <span> {{ row.item.bytes | bytes }} </span>
            </template>

            <!-- Files Cell -->
            <template v-slot:cell(files)="row" >
              <span> {{ row.item.countFiles }} </span>
            </template>

            <!-- Reports Cell -->
            <template v-slot:cell(reports)="row">
              <report-button-set :jobItem=row.item></report-button-set>
            </template>

            <!-- Actions Cell -->
            <template v-slot:cell(actions)="row">
              <manifest-cart-add-remove-item :entity="row.item"></manifest-cart-add-remove-item>
            </template>

            <!-- Row Details Collapse Container -->
            <!-- <template v-slot:row-details="row">
              <b-container class="flex-container">
                <div v-for="index in 30" :key="index">
                  <b-img :src="getRandomImage(row.index)"  alt="Rounded image"></b-img>
                </div>
              </b-container>
            </template> -->
          </b-table>
        </div>
        <div v-else class="text-center p-3">
          No jobs associated with this project yet.
        </div>
      </div>
    </b-card-body>

    <!-- Card Footer -->
    <b-card-footer>
      <b-form-invalid-feedback :state="!errorMessage" class="text-center">
          {{errorMessage}}
      </b-form-invalid-feedback>
    </b-card-footer>
  </b-card>
</div>
</template>

<script>

import ReportButtonSet from '#/ui/Components/ReportButtonSet.vue';
import 'flatpickr/dist/flatpickr.css';
import { JobListSession } from '#/services/jobs';
import JobCardView from './Jobs/JobCardView.vue';
import JobMediaWrapper from '#/ui/Components/Jobs/JobMediaWrapper.vue';
import ManifestCartAddRemoveItem from '#/ui/Components/Manifest/ManifestCartAddRemoveItem.vue';

export default {
  components: {
    JobCardView,
    ReportButtonSet,
    JobMediaWrapper,
    ManifestCartAddRemoveItem,
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
  data() {
    this.$moment.updateLocale('en', {
      calendar: {
        lastWeek: 'L',
        nextWeek: 'L',
        sameElse: 'L',
      },
    });
    const cellClass = 'align-middle text-center';
    const accountId = this.$store.getters.activeAccountId;
    const projectId = this.$store.getters.activeProjectId;
    return {
      session: new JobListSession(accountId, projectId),
      filterSearch: null,
      searchTerm: null,
      filterDateStart: null,
      filterDateFinish: null,
      fields: [
        { key: 'thumb', label: 'Media', class: cellClass, thStyle: { width: '300px'} },
        { key: 'name', label: 'Name', class: cellClass },
        { key: 'date', label: 'Date', class: cellClass },
        { key: 'size', label: 'Size', class: cellClass },
        { key: 'files', label: 'Files', class: cellClass },
        { key: 'reports', label: 'Reports', class: cellClass },
        { key: 'actions', label: '', class: cellClass },
      ],
    };
  },
  created() {
    return this.loadPage();
  },
  computed: {
    errorMessage() {
      return this.session.errorMessage;
    },
    jobList() {
      return this.session.jobList;
    },
    getDefaultView() {
      return this.$store.getters['preferences/getToggleState'];
    },
  },
  methods: {
    switchView(viewType) {
      return this.$store.dispatch('preferences/setToggleState', viewType).then((response) => {
        console.log('Changed toggle state ', response);
      }).catch((error) => {
        console.log('Change toggle state error', error.message);
      });
    },
    scroll() {
      console.debug('JOB SCROLL EVENT');
      if (this.session.loading) {
        return;
      }
      const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.session.loadPage();
      }
    },
    async loadPage() {
      this.session.applyJobNameFilter(this.filterSearch);
      return this.session.loadPage();
    },
    jobAdvanceSearch() {
      console.info(this.searchTerm, this.filterDateStart, this.filterDateFinish);
      this.session.filterSearch(this.searchTerm, this.filterDateStart, this.filterDateFinish);
      return this.session.loadPage();
    },
    jobThumb(item) {
      // TODO: move to model
      if (!item.keyEntityWasExpanded || !item.expandedKeyEntity || item.expandedKeyEntity.expandedThumbnailsList.length < 1) {
        console.log('no thumb for job', item.jobId);
        return undefined;
      }
      const [thumb] = item.expandedKeyEntity.expandedThumbnailsList;
      return thumb.signedUrl;
    },
    jobIsNotCompleted(jobInfo) {
      // TODO: move to model
      return jobInfo.dateFinished === '';
    },
    searchClicked() {
      // TODO: what happens if we run search in the middle of another page loading? Do we get jumbled results?
      this.session.resetPageData();
      this.loadPage();
    },
    openJob(rowItem) {
      console.log('open job clicked');
      const path = `/jobs/${rowItem.jobId}`;
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>

.flex-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: flex-start;
  -ms-flex-line-pack: start;
  align-content: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

</style>
